export const POINTS_AMOUNT = 150;
